// extracted by mini-css-extract-plugin
export var Content = "Content-module--Content--84f48";